import React from 'react';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { DayPicker } from '@components/search/dates/calendar/day-picker/DayPicker';

const Container = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  flexDirection: 'column',
  padding: theme.custom.spacing.medium,
  paddingTop: theme.custom.spacing.medium * 1.5
}));

const DatePickerContainer = styled.div({
  width: '100%'
});

export interface CalendarProps {
  date: string;
  onChange: (date: string) => void;
}

export const Calendar = ({ date, onChange }: CalendarProps) => {
  return (
    <Container>
      <DatePickerContainer>
        <DayPicker day={date} onChange={onChange} />
      </DatePickerContainer>
    </Container>
  );
};
